export const hasAnUpdateAvailable = () => {
  // ChatPlan keeps the banner infrastructure available for future notifications,
  // but suppresses upstream Chatwoot version update alerts.
  return false;
};
